/**
 * Request-shape schemas for the /receipts (receipt scan) route family.
 *
 * These used to live inline in apps/api/src/routes/receipts.ts, invisible
 * to the strictness sweep (strictness.test.ts). Moved here verbatim —
 * shapes are unchanged; only the export location moved.
 */
import { z } from 'zod';
import { ReceiptScanId } from './primitives.js';

export const CreateReceiptScanBody = z.object({ r2_key: z.string().min(1).max(500) });
export const CreateReceiptScanTextBody = z.object({ text: z.string().min(1).max(2000) });

// Answer body — optional match_id / match_kind let the front-end short-circuit
// the AI loop when the staff member taps a leads_to:"link" chip (the chip
// carries the existing routine/task id we want to attach the expense to).
export const ReceiptScanAnswerBody = z.object({
  answer: z.string().min(1).max(2000),
  match_id: z.string().min(1).max(40).optional(),
  match_kind: z.enum(['routine', 'task']).optional(),
});

export const ReceiptScanRejectBody = z.object({ reason: z.string().max(2000).optional() });

export const ReceiptScanIdParams = z.object({ id: ReceiptScanId });
export const ReceiptScanProposalParams = z.object({
  id: ReceiptScanId,
  index: z.coerce.number().int().min(0),
});
